import { render, staticRenderFns } from "./AttendActions.vue?vue&type=template&id=1b6c3718"
import script from "./AttendActions.vue?vue&type=script&lang=js"
export * from "./AttendActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports